import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { LiftModuleService } from './lift-module.service';
import { LiftModuleList } from '../models/lift-module-list.model';


@Injectable({ providedIn: 'root' })
export class LiftModuleLookupResolver implements Resolve<HttpResponse<LiftModuleList[]>> {
  constructor(
    private liftModuleService: LiftModuleService
  ) { }

  resolve() {
    const httpParams = new HttpParams()
      .set('orderby', 'Code asc');
    return this.liftModuleService.get(httpParams);
  }
}
